import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

function Header({ onLogout, onAddPlaylist }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // 點選單以外的任何地方就關閉選單，跟 AdminPage 的右鍵選單用同一套做法。
  useEffect(() => {
    if (!showMenu) return;
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [showMenu]);

  const handleLogoutClick = () => {
    setShowConfirm(true);
    setShowMenu(false);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onLogout(); // 執行登出
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  const handleAddPlaylist = () => {
    setShowMenu(false);
    navigate("/playlist"); // ✅ 導向歌單檢視頁
  };

  const handleToEventFunnel = () => {
    setShowMenu(false);
    navigate("/events"); // ✅ 導向事件漏斗頁
  };

  const handleToHome = () => {
    setShowMenu(false);
    navigate("/admin"); 
  };

  return (
    <>
      <header className="admin-header">
        <div className="header-content">
          <div className="admin-header-title"  onClick={() => navigate("/admin")}>管理者系統</div>
          <div className="menu-container" ref={menuRef}>
            <i className="fas fa-bars menu-button" onClick={toggleMenu}></i>
            {showMenu && (
              <div className="dropdown-menu">
                <button onClick={handleToHome}>回首頁</button>
                <button onClick={handleAddPlaylist}>檢視歌單</button>
                <button onClick={handleToEventFunnel}>事件漏斗</button>
                <button onClick={handleLogoutClick}>登出</button>
              </div>
            )}
          </div>
        </div>
      </header>

      {showConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal-box">
            <h4 className="logout-modal-text">確定要登出嗎？</h4>
            <div className="logout-modal-actions">
              <button className="confirm-btn" onClick={handleConfirm}>
                確定
              </button>
              <button className="cancel-btn" onClick={handleCancel}>
                取消
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
